import { render, staticRenderFns } from "./MypageBookmarkList.vue?vue&type=template&id=5ca4e243&"
import script from "./MypageBookmarkList.vue?vue&type=script&lang=ts&"
export * from "./MypageBookmarkList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports